/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function CircleUserFilledIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="circle-user-filled"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M18.183 19.202C18.131 19.249 18.082 19.301 18.027 19.344C17.442 19.794 17.13 20.03 16.478 20.378C15.656 20.818 14.768 21.135 13.853 21.317C12.938 21.499 11.997 21.546 11.069 21.454C9.83 21.332 8.619 20.965 7.522 20.378C6.87 20.03 6.558 19.794 5.973 19.344C5.918 19.301 5.869 19.249 5.817 19.202C5.878 19.135 5.936 19.064 6 19C6.505 18.497 7.065 18.054 7.678 17.689C8.749 17.051 9.96 16.656 11.201 16.538C12.977 16.369 14.789 16.776 16.322 17.689C16.935 18.054 17.495 18.497 18 19C18.064 19.064 18.122 19.135 18.183 19.202Z" data-tinysvg-shape="path" stroke="none" fill={color} data-fill-tone="primary" />
          <circle cx={12} cy={12} r={9.5} stroke={color} fill="none" data-stroke-tone="primary" />
          <circle cx={12} cy={10} r={3.778} stroke={color} fill={color} data-stroke-tone="primary" data-fill-tone="primary" />
          <path d="M6 19A8.45 8.45 0 0 1 18 19" data-tinysvg-shape="arc" data-tinysvg-arc="12 24.95 8.45 8.45 224.76 315.24 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
